import React from 'react';
import UI from '../ui';

const { Spinner } = UI;

export const FullWidthCellRenderer = ({ data }) => {
	if (data.fullWidthRow === true) {
		return (
			<div className="common-grid full-width-cell-renderer">
				{data.showSpinner ? (
					<Spinner msg="" mask={false} />
				) : (
					<p className="end-message">{data.endOfDataMessage}</p>
				)}
			</div>
		);
	}

	return null;
};
